import { Button } from '@/components/ui/button.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import type { PurchaseResponse } from '@ozon-ai/procurement/contracts';
import type { ICellRendererParams } from 'ag-grid-community';
import { MoreHorizontal } from 'lucide-react';

export interface PurchaseListActionsCellParams extends ICellRendererParams<PurchaseResponse> {
  onEdit?: (purchase: PurchaseResponse) => void;
  onView?: (purchase: PurchaseResponse) => void;
  onDeactivate?: (purchase: PurchaseResponse) => void;
}

export function PurchaseListActionsCell(params: PurchaseListActionsCellParams) {
  const purchase = params.data;
  if (!purchase) return null;

  const isDraft = purchase.status === 'draft';
  const isSigned = purchase.status === 'signed';
  const canDeactivate = (isDraft || isSigned) && !purchase.inactive;

  return (
    <div className="flex h-full items-center justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="size-8 shrink-0"
              onClick={(event) => event.stopPropagation()}
            />
          }
        >
          <MoreHorizontal className="size-4" aria-hidden />
          <span className="sr-only">Действия</span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" sideOffset={4} className="min-w-44">
          {isDraft && (
            <DropdownMenuItem
              onClick={(event) => {
                event.stopPropagation();
                params.onEdit?.(purchase);
              }}
            >
              Редактировать
            </DropdownMenuItem>
          )}
          {isSigned && (
            <DropdownMenuItem
              onClick={(event) => {
                event.stopPropagation();
                params.onView?.(purchase);
              }}
            >
              Просмотр
            </DropdownMenuItem>
          )}
          {canDeactivate && (
            <DropdownMenuItem
              variant="destructive"
              onClick={(event) => {
                event.stopPropagation();
                params.onDeactivate?.(purchase);
              }}
            >
              Деактивировать
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
